module.exports = __webpack_public_path__ + "static/img/data3-list1.d7304744.png";